import { getArgumentValue } from '../getArgumentValue.js';

export const validateFlowControl = async ({ step, status }) => {
  const args = step?.arguments;

  const emailToValue = await getArgumentValue({ arg: args?.emailTo, opts: { format: 'human' } });
  const logMessageValue = await getArgumentValue({ arg: args?.logMessage, opts: { format: 'human' } });
  const emailSubjectValue = await getArgumentValue({ arg: args?.emailSubject, opts: { format: 'human' } });
  const emailBodyValue = await getArgumentValue({ arg: args?.emailBody, opts: { format: 'human' } });

  // Helper to check if a lexical input contains any block/variable references
  const hasBlockReference = (arg) => {
    if (arg?.type !== 'lexical' || !arg?.value?.root?.children) {
      return false;
    }
    const checkChildren = (children) => {
      return children.some((child) => {
        if (child.type === 'block') {
          return true;
        }
        if (child.children) {
          return checkChildren(child.children);
        }
        return false;
      });
    };
    return checkChildren(arg.value.root.children);
  };

  if (args?.emitLog && !logMessageValue) {
    return { status, message: 'Set log message' };
  }

  if (args?.sendEmail && !emailToValue) {
    return { status, message: 'Set email recipient' };
  }

  // Only validate email format if it's a literal email (not a variable reference)
  if (args?.sendEmail && emailToValue && !hasBlockReference(args?.emailTo)) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailToValue)) {
      return { status: 'invalid', message: 'Invalid email format' };
    }
  }

  if (args?.sendEmail && !emailSubjectValue) {
    return { status, message: 'Set email subject' };
  }

  if (args?.sendEmail && !emailBodyValue) {
    return { status, message: 'Set email body' };
  }

  return { status: 'valid' };
};
